import React, { FC } from "react"

interface Props {
  className?: string
}

const ChevronLeftIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M15 18L9 12L15 6"
        stroke="#545E78"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChevronLeftIcon
